export const GET_SESSION_TOKEN_REQUEST = 'GET_SESSION_TOKEN_REQUEST';
export const GET_SESSION_TOKEN_SUCCESS = 'GET_SESSION_TOKEN_SUCCESS';
export const GET_SESSION_TOKEN_FAILURE = 'GET_SESSION_TOKEN_FAILURE';

export const SET_SESSION_TOKEN_REQUEST = 'SET_SESSION_TOKEN_REQUEST';
export const SET_SESSION_TOKEN_SUCCESS = 'SET_SESSION_TOKEN_SUCCESS';
export const SET_SESSION_TOKEN_FAILURE = 'SET_SESSION_TOKEN_FAILURE';

export const REMOVE_SESSION_TOKEN_REQUEST = 'REMOVE_SESSION_TOKEN_REQUEST';
export const REMOVE_SESSION_TOKEN_SUCCESS = 'REMOVE_SESSION_TOKEN_SUCCESS';
export const REMOVE_SESSION_TOKEN_FAILURE = 'REMOVE_SESSION_TOKEN_FAILURE';

export const FETCH_SESSION_TOKEN_COOKIE_REQUEST =
  'FETCH_SESSION_TOKEN_COOKIE_REQUEST';
export const FETCH_SESSION_TOKEN_COOKIE_SUCCESS =
  'FETCH_SESSION_TOKEN_COOKIE_SUCCESS';
export const FETCH_SESSION_TOKEN_COOKIE_FAILURE =
  'FETCH_SESSION_TOKEN_COOKIE_FAILURE';

export const FETCH_DBE_SESSION_REQUEST = 'FETCH_DBE_SESSION_REQUEST';
export const FETCH_DBE_SESSION_SUCCESS = 'FETCH_DBE_SESSION_SUCCESS';
export const FETCH_DBE_SESSION_FAILURE = 'FETCH_DBE_SESSION_FAILURE';

export const STORE_DBE_SESSION_REQUEST = 'STORE_DBE_SESSION_REQUEST';
export const STORE_DBE_SESSION_SUCCESS = 'STORE_DBE_SESSION_SUCCESS';
export const STORE_DBE_SESSION_FAILURE = 'STORE_DBE_SESSION_FAILURE';

export const DELETE_DBE_SESSION_REQUEST = 'DELETE_DBE_SESSION_REQUEST';
export const DELETE_DBE_SESSION_SUCCESS = 'DELETE_DBE_SESSION_SUCCESS';
export const DELETE_DBE_SESSION_FAILURE = 'DELETE_DBE_SESSION_FAILURE';

export const NBS_API_LOGIN_REQUEST = 'NBS_API_LOGIN_REQUEST';
export const NBS_API_LOGIN_SUCCESS = 'NBS_API_LOGIN_SUCCESS';
export const NBS_API_LOGIN_FAILURE = 'NBS_API_LOGIN_FAILURE';

export const NBS_API_INDEX_REQUEST = 'NBS_API_INDEX_REQUEST';
export const NBS_API_INDEX_SUCCESS = 'NBS_API_INDEX_SUCCESS';
export const NBS_API_INDEX_FAILURE = 'NBS_API_INDEX_FAILURE';

export const NBS_API_MY_LOCATION_REQUEST = 'NBS_API_MY_LOCATION_REQUEST';
export const NBS_API_MY_LOCATION_SUCCESS = 'NBS_API_MY_LOCATION_SUCCESS';
export const NBS_API_MY_LOCATION_FAILURE = 'NBS_API_MY_LOCATION_FAILURE';

export const NBS_API_GET_ALLOWED_AGES_REQUEST =
  'NBS_API_GET_ALLOWED_AGES_REQUEST';
export const NBS_API_GET_ALLOWED_AGES_SUCCESS =
  'NBS_API_GET_ALLOWED_AGES_SUCCESS';
export const NBS_API_GET_ALLOWED_AGES_FAILURE =
  'NBS_API_GET_ALLOWED_AGES_FAILURE';

export const NBS_API_SEARCH_LOCATION_REQUEST =
  'NBS_API_SEARCH_LOCATION_REQUEST';
export const NBS_API_SEARCH_LOCATION_SUCCESS =
  'NBS_API_SEARCH_LOCATION_SUCCESS';
export const NBS_API_SEARCH_LOCATION_FAILURE =
  'NBS_API_SEARCH_LOCATION_FAILURE';

export const RESET_CREATE_ACCOUT_DATA = 'RESET_CREATE_ACCOUT_DATA';
export const SET_USER_CREATE_ACCOUT_DATA = 'SET_USER_CREATE_ACCOUT_DATA';

export const NBS_API_EMAIL_REGISTER_REQUEST = 'NBS_API_EMAIL_REGISTER_REQUEST';
export const NBS_API_EMAIL_REGISTER_SUCCESS = 'NBS_API_EMAIL_REGISTER_SUCCESS';
export const NBS_API_EMAIL_REGISTER_FAILURE = 'NBS_API_EMAIL_REGISTER_FAILURE';

export const NBS_API_CHECK_USERNAME_REQUEST = 'NBS_API_CHECK_USERNAME_REQUEST';
export const NBS_API_CHECK_USERNAME_SUCCESS = 'NBS_API_CHECK_USERNAME_SUCCESS';
export const NBS_API_CHECK_USERNAME_FAILURE = 'NBS_API_CHECK_USERNAME_FAILURE';

export const NBS_API_CHECK_FIRST_NAME_REQUEST =
  'NBS_API_CHECK_FIRST_NAME_REQUEST';
export const NBS_API_CHECK_FIRST_NAME_SUCCESS =
  'NBS_API_CHECK_FIRST_NAME_SUCCESS';
export const NBS_API_CHECK_FIRST_NAME_FAILURE =
  'NBS_API_CHECK_FIRST_NAME_FAILURE';

export const NBS_API_APPLE_REQUEST = 'NBS_API_APPLE_REQUEST';
export const NBS_API_APPLE_SUCCESS = 'NBS_API_APPLE_SUCCESS';
export const NBS_API_APPLE_FAILURE = 'NBS_API_APPLE_FAILURE';

export const STORE_APPLE_DATA = 'STORE_APPLE_DATA';

export const NBS_API_EMAIL_LOGIN_REQUEST = 'NBS_API_EMAIL_LOGIN_REQUEST';
export const NBS_API_EMAIL_LOGIN_SUCCESS = 'NBS_API_EMAIL_LOGIN_SUCCESS';
export const NBS_API_EMAIL_LOGIN_FAILURE = 'NBS_API_EMAIL_LOGIN_FAILURE';

export const NBS_API_CONFIRM_EMAIL_REQUEST = 'NBS_API_CONFIRM_EMAIL_REQUEST';
export const NBS_API_CONFIRM_EMAIL_SUCCESS = 'NBS_API_CONFIRM_EMAIL_SUCCESS';
export const NBS_API_CONFIRM_EMAIL_FAILURE = 'NBS_API_CONFIRM_EMAIL_FAILURE';

export const NBS_API_LOGOUT_REQUEST = 'NBS_API_LOGOUT_REQUEST';
export const NBS_API_LOGOUT_SUCCESS = 'NBS_API_LOGOUT_SUCCESS';
export const NBS_API_LOGOUT_FAILURE = 'NBS_API_LOGOUT_FAILURE';

export const NBS_API_GET_MY_MATCHES_REQUEST = 'NBS_API_GET_MY_MATCHES_REQUEST';
export const NBS_API_GET_MY_MATCHES_SUCCESS = 'NBS_API_GET_MY_MATCHES_SUCCESS';
export const NBS_API_GET_MY_MATCHES_FAILURE = 'NBS_API_GET_MY_MATCHES_FAILURE';
export const RESET_GET_MY_MATCHES = 'RESET_GET_MY_MATCHES';

export const NBS_API_GET_QUICK_MATCHES_REQUEST =
  'NBS_API_GET_QUICK_MATCHES_REQUEST';
export const NBS_API_GET_QUICK_MATCHES_SUCCESS =
  'NBS_API_GET_QUICK_MATCHES_SUCCESS';
export const NBS_API_GET_QUICK_MATCHES_FAILURE =
  'NBS_API_GET_QUICK_MATCHES_FAILURE';
export const SET_SHOWING_INDEX_QUICK_MATCH = 'SET_SHOWING_INDEX_QUICK_MATCH';
export const SET_SHOWING_INDEX_QUICK_MATCH_AD =
  'SET_SHOWING_INDEX_QUICK_MATCH_AD';
export const SET_QUICK_MATCHES_ADS = 'SET_QUICK_MATCHES_ADS';
export const QUICK_MATCH_OPTIMISTIC_ADVANCE = 'QUICK_MATCH_OPTIMISTIC_ADVANCE';

export const ITS_MATCH = 'ITS_MATCH';
export const CLEAR_ITS_MATCH = 'CLEAR_ITS_MATCH';

export const NBS_API_INVITE_ACTION_REQUEST = 'NBS_API_INVITE_ACTION_REQUEST';
export const NBS_API_INVITE_ACTION_SUCCESS = 'NBS_API_INVITE_ACTION_SUCCESS';
export const NBS_API_INVITE_ACTION_FAILURE = 'NBS_API_INVITE_ACTION_FAILURE';

export const NBS_API_GET_ADS_REQUEST = 'NBS_API_GET_ADS_REQUEST';
export const NBS_API_GET_ADS_SUCCESS = 'NBS_API_GET_ADS_SUCCESS';
export const NBS_API_GET_ADS_FAILURE = 'NBS_API_GET_ADS_FAILURE';
export const NBS_API_GET_ADS_SIDE_MENU_REQUEST =
  'NBS_API_GET_ADS_SIDE_MENU_REQUEST';
export const NBS_API_GET_ADS_SIDE_MENU_SUCCESS =
  'NBS_API_GET_ADS_SIDE_MENU_SUCCESS';
export const NBS_API_GET_ADS_SIDE_MENU_FAILURE =
  'NBS_API_GET_ADS_SIDE_MENU_FAILURE';
export const NBS_API_GET_ADS_GRID_MENU_REQUEST =
  'NBS_API_GET_ADS_GRID_MENU_REQUEST';
export const NBS_API_GET_ADS_GRID_MENU_SUCCESS =
  'NBS_API_GET_ADS_GRID_MENU_SUCCESS';
export const NBS_API_GET_ADS_GRID_MENU_FAILURE =
  'NBS_API_GET_ADS_GRID_MENU_FAILURE';
export const NBS_API_GET_LOGOUT_ADS_MENU_REQUEST =
  'NBS_API_GET_LOGOUT_ADS_MENU_REQUEST';
export const NBS_API_GET_LOGOUT_ADS_MENU_SUCCESS =
  'NBS_API_GET_LOGOUT_ADS_MENU_SUCCESS';
export const NBS_API_GET_LOGOUT_ADS_MENU_FAILURE =
  'NBS_API_GET_LOGOUT_ADS_MENU_FAILURE';
export const NBS_API_GET_LIST_ADS_REQUEST = 'NBS_API_GET_LIST_ADS_REQUEST';
export const NBS_API_GET_LIST_ADS_SUCCESS = 'NBS_API_GET_LIST_ADS_SUCCESS';
export const NBS_API_GET_LIST_ADS_FAILURE = 'NBS_API_GET_LIST_ADS_FAILURE';

export const NBS_API_CALCULATE_PAYOUT_VALUE_REQUEST =
  'NBS_API_CALCULATE_PAYOUT_VALUE_REQUEST';
export const NBS_API_CALCULATE_PAYOUT_VALUE_SUCCESS =
  'NBS_API_CALCULATE_PAYOUT_VALUE_SUCCESS';
export const NBS_API_CALCULATE_PAYOUT_VALUE_FAILURE =
  'NBS_API_CALCULATE_PAYOUT_VALUE_FAILURE';

export const NBS_API_GET_MY_PROFILE_REQUEST = 'NBS_API_GET_MY_PROFILE_REQUEST';
export const NBS_API_GET_MY_PROFILE_SUCCESS = 'NBS_API_GET_MY_PROFILE_SUCCESS';
export const NBS_API_GET_MY_PROFILE_FAILURE = 'NBS_API_GET_MY_PROFILE_FAILURE';

export const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION';

export const NBS_API_GET_MY_LIKES_REQUEST = 'NBS_API_GET_MY_LIKES_REQUEST';
export const NBS_API_GET_MY_LIKES_SUCCESS = 'NBS_API_GET_MY_LIKES_SUCCESS';
export const NBS_API_GET_MY_LIKES_FAILURE = 'NBS_API_GET_MY_LIKES_FAILURE';

export const NBS_API_GET_LIKES_ME_REQUEST = 'NBS_API_GET_LIKES_ME_REQUEST';
export const NBS_API_GET_LIKES_ME_SUCCESS = 'NBS_API_GET_LIKES_ME_SUCCESS';
export const NBS_API_GET_LIKES_ME_FAILURE = 'NBS_API_GET_LIKES_ME_FAILURE';
export const RESET_GET_LIKES_ME_OPENED = 'RESET_GET_LIKES_ME_OPENED';
export const RESET_GET_LIKES_ME_SEEN = 'RESET_GET_LIKES_ME_SEEN';

export const NBS_API_GET_MUTUAL_LIKES_REQUEST =
  'NBS_API_GET_MUTUAL_LIKES_REQUEST';
export const NBS_API_GET_MUTUAL_LIKES_SUCCESS =
  'NBS_API_GET_MUTUAL_LIKES_SUCCESS';
export const NBS_API_GET_MUTUAL_LIKES_FAILURE =
  'NBS_API_GET_MUTUAL_LIKES_FAILURE';
export const RESET_GET_MUTUAL_LIKES_OPENED = 'RESET_GET_MUTUAL_LIKES_OPENED';
export const RESET_GET_MUTUAL_LIKES_SEEN = 'RESET_GET_MUTUAL_LIKES_SEEN';

export const NBS_API_GET_MY_VIEWS_REQUEST = 'NBS_API_GET_MY_VIEWS_REQUEST';
export const NBS_API_GET_MY_VIEWS_SUCCESS = 'NBS_API_GET_MY_VIEWS_SUCCESS';
export const NBS_API_GET_MY_VIEWS_FAILURE = 'NBS_API_GET_MY_VIEWS_FAILURE';

export const NBS_API_GET_VIEWED_ME_REQUEST = 'NBS_API_GET_VIEWED_ME_REQUEST';
export const NBS_API_GET_VIEWED_ME_SUCCESS = 'NBS_API_GET_VIEWED_ME_SUCCESS';
export const NBS_API_GET_VIEWED_ME_FAILURE = 'NBS_API_GET_VIEWED_ME_FAILURE';
export const RESET_GET_VIEWED_ME_OPENED = 'RESET_GET_VIEWED_ME_OPENED';
export const RESET_GET_VIEWED_ME_SEEN = 'RESET_GET_VIEWED_ME_SEEN';

export const NBS_API_UPDATE_LOCATION_REQUEST =
  'NBS_API_UPDATE_LOCATION_REQUEST';
export const NBS_API_UPDATE_LOCATION_SUCCESS =
  'NBS_API_UPDATE_LOCATION_SUCCESS';
export const NBS_API_UPDATE_LOCATION_FAILURE =
  'NBS_API_UPDATE_LOCATION_FAILURE';
export const RESET_UPDATE_LOCATION = 'RESET_UPDATE_LOCATION';

export const NBS_API_GET_MEMBER_PROFILE_REQUEST =
  'NBS_API_GET_MEMBER_PROFILE_REQUEST';
export const NBS_API_GET_MEMBER_PROFILE_SUCCESS =
  'NBS_API_GET_MEMBER_PROFILE_SUCCESS';
export const NBS_API_GET_MEMBER_PROFILE_FAILURE =
  'NBS_API_GET_MEMBER_PROFILE_FAILURE';

export const NBS_WS_AUTH_DONE_RECEIVED = 'NBS_WS_AUTH_DONE_RECEIVED';
export const NBS_WS_COUNTERS_RECEIVED = 'NBS_WS_COUNTERS_RECEIVED';
export const NBS_WS_FLIRTS_UPDATE_RECEIVED = 'NBS_WS_FLIRTS_UPDATE_RECEIVED';
export const NBS_WS_ITS_MATCH_RECEIVED = 'NBS_WS_ITS_MATCH_RECEIVED';
export const NBS_WS_GET_MESSAGE_SUCCESS = 'NBS_WS_GET_MESSAGE_SUCCESS';
export const NBS_WS_SEND_MESSAGE = 'NBS_WS_SEND_MESSAGE';
export const NBS_WS_SEND_MESSAGE_SUCCESS = 'NBS_WS_SEND_MESSAGE_SUCCESS';
export const NBS_WS_SEND_MESSAGE_FAIL = 'NBS_WS_SEND_MESSAGE_FAIL';
export const NBS_WS_GET_CHAT_HISTORY = 'NBS_WS_GET_CHAT_HISTORY';
export const NBS_WS_GET_CHAT_HISTORY_SUCCESS =
  'NBS_WS_GET_CHAT_HISTORY_SUCCESS';
export const NBS_WS_GET_USER_DATA = 'NBS_WS_GET_USER_DATA';
export const NBS_WS_USER_DATA = 'NBS_WS_USER_DATA';
export const NBS_WS_SEND_TYPING = 'NBS_WS_SEND_TYPING';
export const NBS_WS_GET_TYPING = 'NBS_WS_GET_TYPING';
export const USER_NOT_TYPING = 'USER_NOT_TYPING';
export const NBS_WS_SET_READ = 'NBS_WS_SET_READ';
export const NBS_WS_INVALID_TOKEN = 'NBS_WS_INVALID_TOKEN';
export const NBS_WS_AUTH_BLOCKED = 'NBS_WS_AUTH_BLOCKED';
export const INVALID_SOCKET_AUTH = 'INVALID_SOCKET_AUTH';
export const DELETE_ACTION_REQUIRED = 'DELETE_ACTION_REQUIRED';
export const NBS_WS_PRIVATE = 'NBS_WS_PRIVATE';

export const NBS_API_GET_WHO_IS_ONLINE_RECENT_REQUEST =
  'NBS_API_GET_WHO_IS_ONLINE_RECENT_REQUEST';
export const NBS_API_GET_WHO_IS_ONLINE_RECENT_SUCCESS =
  'NBS_API_GET_WHO_IS_ONLINE_RECENT_SUCCESS';
export const NBS_API_GET_WHO_IS_ONLINE_RECENT_FAILURE =
  'NBS_API_GET_WHO_IS_ONLINE_RECENT_FAILURE';

export const NBS_API_GET_WHO_IS_ONLINE_WEEK_REQUEST =
  'NBS_API_GET_WHO_IS_ONLINE_WEEK_REQUEST';
export const NBS_API_GET_WHO_IS_ONLINE_WEEK_SUCCESS =
  'NBS_API_GET_WHO_IS_ONLINE_WEEK_SUCCESS';
export const NBS_API_GET_WHO_IS_ONLINE_WEEK_FAILURE =
  'NBS_API_GET_WHO_IS_ONLINE_WEEK_FAILURE';

export const NBS_API_GET_BROWSE_REQUEST = 'NBS_API_GET_BROWSE_REQUEST';
export const NBS_API_GET_BROWSE_SUCCESS = 'NBS_API_GET_BROWSE_SUCCESS';
export const NBS_API_GET_BROWSE_FAILURE = 'NBS_API_GET_BROWSE_FAILURE';

export const NBS_API_GET_MY_FAVORITES_REQUEST =
  'NBS_API_GET_MY_FAVORITES_REQUEST';
export const NBS_API_GET_MY_FAVORITES_SUCCESS =
  'NBS_API_GET_MY_FAVORITES_SUCCESS';
export const NBS_API_GET_MY_FAVORITES_FAILURE =
  'NBS_API_GET_MY_FAVORITES_FAILURE';

export const NBS_API_GET_FAVORITED_ME_REQUEST =
  'NBS_API_GET_FAVORITED_ME_REQUEST';
export const NBS_API_GET_FAVORITED_ME_SUCCESS =
  'NBS_API_GET_FAVORITED_ME_SUCCESS';
export const NBS_API_GET_FAVORITED_ME_FAILURE =
  'NBS_API_GET_FAVORITED_ME_FAILURE';
export const RESET_GET_FAVORITED_ME_OPENED = 'RESET_GET_FAVORITED_ME_OPENED';
export const RESET_GET_FAVORITED_ME_SEEN = 'RESET_GET_FAVORITED_ME_SEEN';

export const NBS_API_DEACTIVATE_ACCOUNT_REQUEST =
  'NBS_API_DEACTIVATE_ACCOUNT_REQUEST';
export const NBS_API_DEACTIVATE_ACCOUNT_SUCCESS =
  'NBS_API_DEACTIVATE_ACCOUNT_SUCCESS';
export const NBS_API_DEACTIVATE_ACCOUNT_FAILURE =
  'NBS_API_DEACTIVATE_ACCOUNT_FAILURE';

export const NBS_API_DELETE_ACCOUNT_REQUEST = 'NBS_API_DELETE_ACCOUNT_REQUEST';
export const NBS_API_DELETE_ACCOUNT_SUCCESS = 'NBS_API_DELETE_ACCOUNT_SUCCESS';
export const NBS_API_DELETE_ACCOUNT_FAILURE = 'NBS_API_DELETE_ACCOUNT_FAILURE';

export const NBS_API_CANCEL_WEB_SUBSCRIPTION_REQUEST =
  'NBS_API_CANCEL_WEB_SUBSCRIPTION_REQUEST';
export const NBS_API_CANCEL_WEB_SUBSCRIPTION_SUCCESS =
  'NBS_API_CANCEL_WEB_SUBSCRIPTION_SUCCESS';
export const NBS_API_CANCEL_WEB_SUBSCRIPTION_FAILURE =
  'NBS_API_CANCEL_WEB_SUBSCRIPTION_FAILURE';
export const NBS_API_CANCEL_WEB_SUBSCRIPTION_RESET_DATA =
  'NBS_API_CANCEL_WEB_SUBSCRIPTION_RESET_DATA';

export const NBS_API_REACTIVATE_WEB_SUBSCRIPTION_REQUEST =
  'NBS_API_REACTIVATE_WEB_SUBSCRIPTION_REQUEST';
export const NBS_API_REACTIVATE_WEB_SUBSCRIPTION_SUCCESS =
  'NBS_API_REACTIVATE_WEB_SUBSCRIPTION_SUCCESS';
export const NBS_API_REACTIVATE_WEB_SUBSCRIPTION_FAILURE =
  'NBS_API_REACTIVATE_WEB_SUBSCRIPTION_FAILURE';

export const RESET_ACCOUNT_STATUS = 'RESET_ACCOUNT_STATUS';

export const NBS_API_CONTACT_US_REQUEST = 'NBS_API_CONTACT_US_REQUEST';
export const NBS_API_CONTACT_US_SUCCESS = 'NBS_API_CONTACT_US_SUCCESS';
export const NBS_API_CONTACT_US_FAILURE = 'NBS_API_CONTACT_US_FAILURE';

export const NBS_API_GET_CHATS_REQUEST = 'NBS_API_GET_CHATS_REQUEST';
export const NBS_API_GET_CHATS_SUCCESS = 'NBS_API_GET_CHATS_SUCCESS';
export const NBS_API_GET_CHATS_FAILURE = 'NBS_API_GET_CHATS_FAILURE';
export const RESET_GET_CHATS_OPENED = 'RESET_GET_CHATS_OPENED';
export const RESET_GET_CHATS_SEEN = 'RESET_GET_CHATS_SEEN';

export const NBS_API_GET_SEARCH_CONTROLS_REQUEST =
  'NBS_API_GET_SEARCH_CONTROLS_REQUEST';
export const NBS_API_GET_SEARCH_CONTROLS_SUCCESS =
  'NBS_API_GET_SEARCH_CONTROLS_SUCCESS';
export const NBS_API_GET_SEARCH_CONTROLS_FAILURE =
  'NBS_API_GET_SEARCH_CONTROLS_FAILURE';

export const STORE_BROWSE_ADS_LOCALY = 'STORE_BROWSE_ADS_LOCALY';
export const STORE_WHOISONLINE_RECENT_ADS_LOCALY =
  'STORE_WHOISONLINE_RECENT_ADS_LOCALY';
export const STORE_WHOISONLINE_WEEK_ADS_LOCALY =
  'STORE_WHOISONLINE_WEEK_ADS_LOCALY';

export const NBS_API_SEARCH_USERS_REQUEST = 'NBS_API_SEARCH_USERS_REQUEST';
export const NBS_API_SEARCH_USERS_SUCCESS = 'NBS_API_SEARCH_USERS_SUCCESS';
export const NBS_API_SEARCH_USERS_FAILURE = 'NBS_API_SEARCH_USERS_FAILURE';

export const SET_SEARCH_CONTROLS = 'SET_SEARCH_CONTROLS';
export const UPDATE_SEARCH_CONTROLS = 'UPDATE_SEARCH_CONTROLS';
export const RESET_SEARCH_CONTROLS = 'RESET_SEARCH_CONTROLS';
export const RESET_SEARCH_USER_LIST = 'RESET_SEARCH_USER_LIST';
export const TOGGLE_ADVANCED_SEARCH_CONTROLS =
  'TOGGLE_ADVANCED_SEARCH_CONTROLS';

export const NBS_API_GET_PROFILE_CONTROLS_REQUEST =
  'NBS_API_GET_PROFILE_CONTROLS_REQUEST';
export const NBS_API_GET_PROFILE_CONTROLS_SUCCESS =
  'NBS_API_GET_PROFILE_CONTROLS_SUCCESS';
export const NBS_API_GET_PROFILE_CONTROLS_FAILURE =
  'NBS_API_GET_PROFILE_CONTROLS_FAILURE';

export const NBS_API_GET_FORGOT_PASSWORD_REQUEST =
  'NBS_API_GET_FORGOT_PASSWORD_REQUEST';
export const NBS_API_GET_FORGOT_PASSWORD_SUCCESS =
  'NBS_API_GET_FORGOT_PASSWORD_SUCCESS';
export const NBS_API_GET_FORGOT_PASSWORD_FAILURE =
  'NBS_API_GET_FORGOT_PASSWORD_FAILURE';

export const NBS_API_SET_NEW_PASSWORD_REQUEST =
  'NBS_API_SET_NEW_PASSWORD_REQUEST';
export const NBS_API_SET_NEW_PASSWORD_SUCCESS =
  'NBS_API_SET_NEW_PASSWORD_SUCCESS';
export const NBS_API_SET_NEW_PASSWORD_FAILURE =
  'NBS_API_SET_NEW_PASSWORD_FAILURE';

export const NBS_API_EDIT_PROFILE_REQUEST = 'NBS_API_EDIT_PROFILE_REQUEST';
export const NBS_API_EDIT_PROFILE_SUCCESS = 'NBS_API_EDIT_PROFILE_SUCCESS';
export const NBS_API_EDIT_PROFILE_FAILURE = 'NBS_API_EDIT_PROFILE_FAILURE';
export const UPDATE_MY_PROFILE = 'UPDATE_MY_PROFILE';
export const RESET_MY_PROFILE = 'RESET_MY_PROFILE';
export const RESET_EDIT_PROFILE = 'RESET_EDIT_PROFILE';
export const SAVE_EDIT_PROFILE_DATA = 'SAVE_EDIT_PROFILE_DATA';

export const NBS_API_SWAP_IMAGES_REQUEST = 'NBS_API_SWAP_IMAGES_REQUEST';
export const NBS_API_SWAP_IMAGES_SUCCESS = 'NBS_API_SWAP_IMAGES_SUCCESS';
export const NBS_API_SWAP_IMAGES_FAILURE = 'NBS_API_SWAP_IMAGES_FAILURE';

export const NBS_API_DELETE_IMAGE_REQUEST = 'NBS_API_DELETE_IMAGE_REQUEST';
export const NBS_API_DELETE_IMAGE_SUCCESS = 'NBS_API_DELETE_IMAGE_SUCCESS';
export const NBS_API_DELETE_IMAGE_FAILURE = 'NBS_API_DELETE_IMAGE_FAILURE';

export const NBS_API_UPLOAD_IMAGE_REQUEST = 'NBS_API_UPLOAD_IMAGE_REQUEST';
export const NBS_API_UPLOAD_IMAGE_SUCCESS = 'NBS_API_UPLOAD_IMAGE_SUCCESS';
export const NBS_API_UPLOAD_IMAGE_FAILURE = 'NBS_API_UPLOAD_IMAGE_FAILURE';
export const SET_IMAGE_FOR_UPLOAD = 'SET_IMAGE_FOR_UPLOAD';
export const CLEAR_IMAGE_UPLOAD_ERROR = 'CLEAR_IMAGE_UPLOAD_ERROR';

export const ONBOARDING_ADD_IMAGE = 'ONBOARDING_ADD_IMAGE';
export const ONBOARDING_REMOVE_IMAGE = 'ONBOARDING_REMOVE_IMAGE';

export const NBS_API_UPLOAD_IMAGE_TO_CDN_REQUEST =
  'NBS_API_UPLOAD_IMAGE_TO_CDN_REQUEST';
export const NBS_API_UPLOAD_IMAGE_TO_CDN_SUCCESS =
  'NBS_API_UPLOAD_IMAGE_TO_CDN_SUCCESS';
export const NBS_API_UPLOAD_IMAGE_TO_CDN_FAILURE =
  'NBS_API_UPLOAD_IMAGE_TO_CDN_FAILURE';

export const NBS_API_REPORT_USER_REQUEST = 'NBS_API_REPORT_USER_REQUEST';
export const NBS_API_REPORT_USER_SUCCESS = 'NBS_API_REPORT_USER_SUCCESS';
export const NBS_API_REPORT_USER_FAILURE = 'NBS_API_REPORT_USER_FAILURE';

export const NBS_API_BLOCK_USER_REQUEST = 'NBS_API_BLOCK_USER_REQUEST';
export const NBS_API_BLOCK_USER_SUCCESS = 'NBS_API_BLOCK_USER_SUCCESS';
export const NBS_API_BLOCK_USER_FAILURE = 'NBS_API_BLOCK_USER_FAILURE';

export const NBS_API_SET_MERGED_PROJ_ACKNOWLEDGED_REQUEST =
  'NBS_API_SET_MERGED_PROJ_ACKNOWLEDGED_REQUEST';
export const NBS_API_SET_MERGED_PROJ_ACKNOWLEDGED_SUCCESS =
  'NBS_API_SET_MERGED_PROJ_ACKNOWLEDGED_SUCCESS';
export const NBS_API_SET_MERGED_PROJ_ACKNOWLEDGED_FAILURE =
  'NBS_API_SET_MERGED_PROJ_ACKNOWLEDGED_FAILURE';

export const NBS_API_DELETE_USER_CHAT_AND_UNMATCH_REQUEST =
  'NBS_API_DELETE_USER_CHAT_AND_UNMATCH_REQUEST';
export const NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS =
  'NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS';
export const NBS_API_DELETE_USER_CHAT_AND_UNMATCH_FAILURE =
  'NBS_API_DELETE_USER_CHAT_AND_UNMATCH_FAILURE';

export const NBS_API_FAVORITE_USER_REQUEST = 'NBS_API_FAVORITE_USER_REQUEST';
export const NBS_API_FAVORITE_USER_SUCCESS = 'NBS_API_FAVORITE_USER_SUCCESS';
export const NBS_API_FAVORITE_USER_FAILURE = 'NBS_API_FAVORITE_USER_FAILURE';

export const NBS_API_REQUEST_USER_PHOTO_REQUEST =
  'NBS_API_REQUEST_USER_PHOTO_REQUEST';
export const NBS_API_REQUEST_USER_PHOTO_SUCCESS =
  'NBS_API_REQUEST_USER_PHOTO_SUCCESS';
export const NBS_API_REQUEST_USER_PHOTO_FAILURE =
  'NBS_API_REQUEST_USER_PHOTO_FAILURE';

export const NBS_API_GET_USER_PREFERENCES_REQUEST =
  'NBS_API_GET_USER_PREFERENCES_REQUEST';
export const NBS_API_GET_USER_PREFERENCES_SUCCESS =
  'NBS_API_GET_USER_PREFERENCES_SUCCESS';
export const NBS_API_GET_USER_PREFERENCES_FAILURE =
  'NBS_API_GET_USER_PREFERENCES_FAILURE';

export const NBS_API_GET_FLIRT_MESSAGES_REQUEST =
  'NBS_API_GET_FLIRT_MESSAGES_REQUEST';
export const NBS_API_GET_FLIRT_MESSAGES_SUCCESS =
  'NBS_API_GET_FLIRT_MESSAGES_SUCCESS';
export const NBS_API_GET_FLIRT_MESSAGES_FAILURE =
  'NBS_API_GET_FLIRT_MESSAGES_FAILURE';

export const NBS_API_GET_WEB_SUBSCRIPTION_REQUEST =
  'NBS_API_GET_WEB_SUBSCRIPTION_REQUEST';
export const NBS_API_GET_WEB_SUBSCRIPTION_SUCCESS =
  'NBS_API_GET_WEB_SUBSCRIPTION_SUCCESS';
export const NBS_API_GET_WEB_SUBSCRIPTION_FAILURE =
  'NBS_API_GET_WEB_SUBSCRIPTION_FAILURE';

export const NBS_API_GET_SUBSCRIPTIONS_LIST_REQUEST =
  'NBS_API_GET_SUBSCRIPTIONS_LIST_REQUEST';
export const NBS_API_GET_SUBSCRIPTIONS_LIST_SUCCESS =
  'NBS_API_GET_SUBSCRIPTIONS_LIST_SUCCESS';
export const NBS_API_GET_SUBSCRIPTIONS_LIST_FAILURE =
  'NBS_API_GET_SUBSCRIPTIONS_LIST_FAILURE';

export const SET_PAYMENT_DATA = 'SET_PAYMENT_DATA';
export const RESET_PAYMENT_DATA = 'RESET_PAYMENT_DATA';
export const SET_MAILING_ID_PROMO = 'SET_MAILING_ID_PROMO';

export const NBS_API_GET_CONFIG_REQUEST = 'NBS_API_GET_CONFIG_REQUEST';
export const NBS_API_GET_CONFIG_SUCCESS = 'NBS_API_GET_CONFIG_SUCCESS';
export const NBS_API_GET_CONFIG_FAILURE = 'NBS_API_GET_CONFIG_FAILURE';

export const NBS_API_INIT_WEB_PAYMENT_REQUEST =
  'NBS_API_INIT_WEB_PAYMENT_REQUEST';
export const NBS_API_INIT_WEB_PAYMENT_SUCCESS =
  'NBS_API_INIT_WEB_PAYMENT_SUCCESS';
export const NBS_API_INIT_WEB_PAYMENT_FAILURE =
  'NBS_API_INIT_WEB_PAYMENT_FAILURE';

export const NBS_API_FINISH_WEB_PAYMENT_REQUEST =
  'NBS_API_FINISH_WEB_PAYMENT_REQUEST';
export const NBS_API_FINISH_WEB_PAYMENT_SUCCESS =
  'NBS_API_FINISH_WEB_PAYMENT_SUCCESS';
export const NBS_API_FINISH_WEB_PAYMENT_FAILURE =
  'NBS_API_FINISH_WEB_PAYMENT_FAILURE';
export const RESET_FINISH_WEB_PAYMENT = 'RESET_FINISH_WEB_PAYMENT';

export const NBS_API_ACTIVATE_VIP_REQUEST = 'NBS_API_ACTIVATE_VIP_REQUEST';
export const NBS_API_ACTIVATE_VIP_SUCCESS = 'NBS_API_ACTIVATE_VIP_SUCCESS';
export const NBS_API_ACTIVATE_VIP_FAILURE = 'NBS_API_ACTIVATE_VIP_FAILURE';

export const NBS_API_REMOVE_UNSEEN_FLAG_REQUEST =
  'NBS_API_REMOVE_UNSEEN_FLAG_REQUEST';
export const NBS_API_REMOVE_UNSEEN_FLAG_SUCCESS =
  'NBS_API_REMOVE_UNSEEN_FLAG_SUCCESS';
export const NBS_API_REMOVE_UNSEEN_FLAG_FAILURE =
  'NBS_API_REMOVE_UNSEEN_FLAG_FAILURE';

export const NBS_API_REMOVE_UNOPENED_FLAG_REQUEST =
  'NBS_API_REMOVE_UNOPENED_FLAG_REQUEST';
export const NBS_API_REMOVE_UNOPENED_FLAG_SUCCESS =
  'NBS_API_REMOVE_UNOPENED_FLAG_SUCCESS';
export const NBS_API_REMOVE_UNOPENED_FLAG_FAILURE =
  'NBS_API_REMOVE_UNOPENED_FLAG_FAILURE';

export const NBS_API_ENABLE_PRIVATE_REQUEST = 'NBS_API_ENABLE_PRIVATE_REQUEST';
export const NBS_API_ENABLE_PRIVATE_SUCCESS = 'NBS_API_ENABLE_PRIVATE_SUCCESS';
export const NBS_API_ENABLE_PRIVATE_FAILURE = 'NBS_API_ENABLE_PRIVATE_FAILURE';

export const NBS_API_DISABLE_PRIVATE_REQUEST =
  'NBS_API_DISABLE_PRIVATE_REQUEST';
export const NBS_API_DISABLE_PRIVATE_SUCCESS =
  'NBS_API_DISABLE_PRIVATE_SUCCESS';
export const NBS_API_DISABLE_PRIVATE_FAILURE =
  'NBS_API_DISABLE_PRIVATE_FAILURE';

export const NBS_API_CONFIRM_OPT_IN_REQUEST = 'NBS_API_CONFIRM_OPT_IN_REQUEST';
export const NBS_API_CONFIRM_OPT_IN_SUCCESS = 'NBS_API_CONFIRM_OPT_IN_SUCCESS';
export const NBS_API_CONFIRM_OPT_IN_FAILURE = 'NBS_API_CONFIRM_OPT_IN_FAILURE';

export const NBS_API_SET_CO_REG_WELCOME_SEEN_REQUEST =
  'NBS_API_SET_CO_REG_WELCOME_SEEN_REQUEST';
export const NBS_API_SET_CO_REG_WELCOME_SEEN_SUCCESS =
  'NBS_API_SET_CO_REG_WELCOME_SEEN_SUCCESS';
export const NBS_API_SET_CO_REG_WELCOME_SEEN_FAILURE =
  'NBS_API_SET_CO_REG_WELCOME_SEEN_FAILURE';

export const NBS_WS_VIP_UPDATE = 'NBS_WS_VIP_UPDATE';
export const SAVE_REDUX_STATE_TO_STORAGE = 'SAVE_REDUX_STATE_TO_STORAGE';

export const REFRESH_DATA = 'REFRESH_DATA';
export const NBS_WS_STOP_AND_DONT_RECONNECT = 'NBS_WS_STOP_AND_DONT_RECONNECT';
export const RESET_STOP_AND_DONT_RECONNECT = 'RESET_STOP_AND_DONT_RECONNECT';

export const NBS_API_SET_ACKNOWLEDGED_REQUEST =
  'NBS_API_SET_ACKNOWLEDGED_REQUEST';
export const NBS_API_SET_ACKNOWLEDGED_SUCCESS =
  'NBS_API_SET_ACKNOWLEDGED_SUCCESS';
export const NBS_API_SET_ACKNOWLEDGED_FAILURE =
  'NBS_API_SET_ACKNOWLEDGED_FAILURE';

export const NBS_API_SET_NEARBY_CONNECT_MESSAGE_REQUEST =
  'NBS_API_SET_NEARBY_CONNECT_MESSAGE_REQUEST';
export const NBS_API_SET_NEARBY_CONNECT_MESSAGE_SUCCESS =
  'NBS_API_SET_NEARBY_CONNECT_MESSAGE_SUCCESS';
export const NBS_API_SET_NEARBY_CONNECT_MESSAGE_FAILURE =
  'NBS_API_SET_NEARBY_CONNECT_MESSAGE_FAILURE';

export const SET_MISSING_PHOTO_MODAL = 'SET_MISSING_PHOTO_MODAL';
export const RESET_MISSING_PHOTO_MODAL = 'RESET_MISSING_PHOTO_MODAL';

export const RESET_ALL_USER_LISTS = 'RESET_ALL_USER_LISTS';
export const RESET_SINGLE_USER_LIST = 'RESET_SINGLE_USER_LIST';
export const MARK_USER_LIST_AS_RESETED = 'MARK_USER_LIST_AS_RESETED';

export const NBS_API_UNSUBSCRIBE_EMAIL_REQUEST =
  'NBS_API_UNSUBSCRIBE_EMAIL_REQUEST';
export const NBS_API_UNSUBSCRIBE_EMAIL_SUCCESS =
  'NBS_API_UNSUBSCRIBE_EMAIL_SUCCESS';
export const NBS_API_UNSUBSCRIBE_EMAIL_FAILURE =
  'NBS_API_UNSUBSCRIBE_EMAIL_FAILURE';

export const NBS_API_RESUBSCRIBE_EMAIL_REQUEST =
  'NBS_API_RESUBSCRIBE_EMAIL_REQUEST';
export const NBS_API_RESUBSCRIBE_EMAIL_SUCCESS =
  'NBS_API_RESUBSCRIBE_EMAIL_SUCCESS';
export const NBS_API_RESUBSCRIBE_EMAIL_FAILURE =
  'NBS_API_RESUBSCRIBE_EMAIL_FAILURE';

export const NBS_API_ADD_UNSUBSCRIBE_REASON_REQUEST =
  'NBS_API_ADD_UNSUBSCRIBE_REASON_REQUEST';
export const NBS_API_ADD_UNSUBSCRIBE_REASON_SUCCESS =
  'NBS_API_ADD_UNSUBSCRIBE_REASON_SUCCESS';
export const NBS_API_ADD_UNSUBSCRIBE_REASON_FAILURE =
  'NBS_API_ADD_UNSUBSCRIBE_REASON_FAILURE';

export const NBS_API_TRACK_AFFILIATE_CLICK_REQUEST =
  'NBS_API_TRACK_AFFILIATE_CLICK_REQUEST';
export const NBS_API_TRACK_AFFILIATE_CLICK_SUCCESS =
  'NBS_API_TRACK_AFFILIATE_CLICK_SUCCESS';
export const NBS_API_TRACK_AFFILIATE_CLICK_FAILURE =
  'NBS_API_TRACK_AFFILIATE_CLICK_FAILURE';

export const NBS_API_WENT_TO_PAYMENT_OPTIONS_REQUEST =
  'NBS_API_WENT_TO_PAYMENT_OPTIONS_REQUEST';
export const NBS_API_WENT_TO_PAYMENT_OPTIONS_SUCCESS =
  'NBS_API_WENT_TO_PAYMENT_OPTIONS_SUCCESS';
export const NBS_API_WENT_TO_PAYMENT_OPTIONS_FAILURE =
  'NBS_API_WENT_TO_PAYMENT_OPTIONS_FAILURE';

export const NBS_API_SET_POSTPONED_UPGRADE_SHOWN_REQUEST =
  'NBS_API_SET_POSTPONED_UPGRADE_SHOWN_REQUEST';
export const NBS_API_SET_POSTPONED_UPGRADE_SHOWN_SUCCESS =
  'NBS_API_SET_POSTPONED_UPGRADE_SHOWN_SUCCESS';
export const NBS_API_SET_POSTPONED_UPGRADE_SHOWN_FAILURE =
  'NBS_API_SET_POSTPONED_UPGRADE_SHOWN_FAILURE';

export const SET_DO_NOT_SELL_INFO_REQUEST = 'SET_DO_NOT_SELL_INFO_REQUEST';
export const SET_DO_NOT_SELL_INFO_SUCCESS = 'SET_DO_NOT_SELL_INFO_SUCCESS';
export const SET_DO_NOT_SELL_INFO_FAILURE = 'SET_DO_NOT_SELL_INFO_FAILURE';

export const NBS_API_GET_CROSS_SALE_OFFER_REQUEST =
  'NBS_API_GET_CROSS_SALE_OFFER_REQUEST';
export const NBS_API_GET_CROSS_SALE_OFFER_SUCCESS =
  'NBS_API_GET_CROSS_SALE_OFFER_SUCCESS';
export const NBS_API_GET_CROSS_SALE_OFFER_FAILURE =
  'NBS_API_GET_CROSS_SALE_OFFER_FAILURE';

export const NBS_API_GET_STEPDOWN_SUBSCRIPTION_REQUEST =
  'NBS_API_GET_STEPDOWN_SUBSCRIPTION_REQUEST';
export const NBS_API_GET_STEPDOWN_SUBSCRIPTION_SUCCESS =
  'NBS_API_GET_STEPDOWN_SUBSCRIPTION_SUCCESS';
export const NBS_API_GET_STEPDOWN_SUBSCRIPTION_FAILURE =
  'NBS_API_GET_STEPDOWN_SUBSCRIPTION_FAILURE';

export const NBS_API_TRANS_COREG_LOOKUP_REQUEST =
  'NBS_API_TRANS_COREG_LOOKUP_REQUEST';
export const NBS_API_TRANS_COREG_LOOKUP_SUCCESS =
  'NBS_API_TRANS_COREG_LOOKUP_SUCCESS';
export const NBS_API_TRANS_COREG_LOOKUP_FAILURE =
  'NBS_API_TRANS_COREG_LOOKUP_FAILURE';

export const GET_STORED_LANGUAGE_REQUEST = 'GET_STORED_LANGUAGE_REQUEST';
export const GET_STORED_LANGUAGE_SUCCESS = 'GET_STORED_LANGUAGE_SUCCESS';
export const GET_STORED_LANGUAGE_FAILURE = 'GET_STORED_LANGUAGE_FAILURE';

export const SET_STORED_LANGUAGE_REQUEST = 'SET_STORED_LANGUAGE_REQUEST';
export const SET_STORED_LANGUAGE_SUCCESS = 'SET_STORED_LANGUAGE_SUCCESS';
export const SET_STORED_LANGUAGE_FAILURE = 'SET_STORED_LANGUAGE_FAILURE';

export const NBS_API_ONE_CLICK_SIGNUP_REQUEST =
  'NBS_API_ONE_CLICK_SIGNUP_REQUEST';
export const NBS_API_ONE_CLICK_SIGNUP_SUCCESS =
  'NBS_API_ONE_CLICK_SIGNUP_SUCCESS';
export const NBS_API_ONE_CLICK_SIGNUP_FAILURE =
  'NBS_API_ONE_CLICK_SIGNUP_FAILURE';

export const NBS_API_ONE_CLICK_LOGIN_REQUEST =
  'NBS_API_ONE_CLICK_LOGIN_REQUEST';
export const NBS_API_ONE_CLICK_LOGIN_SUCCESS =
  'NBS_API_ONE_CLICK_LOGIN_SUCCESS';
export const NBS_API_ONE_CLICK_LOGIN_FAILURE =
  'NBS_API_ONE_CLICK_LOGIN_FAILURE';

export const NBS_API_GET_SIGNUP_COREG_REQUEST =
  'NBS_API_GET_SIGNUP_COREG_REQUEST';
export const NBS_API_GET_SIGNUP_COREG_SUCCESS =
  'NBS_API_GET_SIGNUP_COREG_SUCCESS';
export const NBS_API_GET_SIGNUP_COREG_FAILURE =
  'NBS_API_GET_SIGNUP_COREG_FAILURE';

export const NBS_API_REFUND_WITH_NEW_CREDIT_CARD_REQUEST =
  'NBS_API_REFUND_WITH_NEW_CREDIT_CARD_REQUEST';
export const NBS_API_REFUND_WITH_NEW_CREDIT_CARD_SUCCESS =
  'NBS_API_REFUND_WITH_NEW_CREDIT_CARD_SUCCESS';
export const NBS_API_REFUND_WITH_NEW_CREDIT_CARD_FAILURE =
  'NBS_API_REFUND_WITH_NEW_CREDIT_CARD_FAILURE';

export const NBS_WS_3DSV2_UPDATE_PROCESSING = 'NBS_WS_3DSV2_UPDATE_PROCESSING';
export const NBS_WS_VIP_3DSV2_UPDATE_SUCCESS =
  'NBS_WS_VIP_3DSV2_UPDATE_SUCCESS';
export const NBS_WS_3DSV2_UPDATE_FAILED = 'NBS_WS_3DSV2_UPDATE_FAILED';
export const RESET_WS_3DSV2_UPDATE_PROCESSING =
  'RESET_WS_3DSV2_UPDATE_PROCESSING';

export const GO_TO_NEXT_MODAL = 'GO_TO_NEXT_MODAL';
export const GO_TO_PREVIOUS_MODAL = 'GO_TO_PREVIOUS_MODAL';
export const DELETE_MODAL = 'DELETE_MODAL';

export const ONBOARDING_SET_VALUE = 'ONBOARDING_SET_VALUE';
export const DELETE_ALL_ACTIONS_REQUIRED = 'DELETE_ALL_ACTIONS_REQUIRED';

export const NBS_API_GET_NEARBY_CONNECT_STATUS_REQUEST =
  'NBS_API_GET_NEARBY_CONNECT_STATUS_REQUEST';
export const NBS_API_GET_NEARBY_CONNECT_STATUS_SUCCESS =
  'NBS_API_GET_NEARBY_CONNECT_STATUS_SUCCESS';
export const NBS_API_GET_NEARBY_CONNECT_STATUS_FAILURE =
  'NBS_API_GET_NEARBY_CONNECT_STATUS_FAILURE';
export const NBS_API_RESET_GET_NEARBY_CONNECT =
  'NBS_API_RESET_GET_NEARBY_CONNECT';

export const NBS_API_DISABLE_NEARBY_CONNECT_SETUP_REQUEST =
  'NBS_API_DISABLE_NEARBY_CONNECT_SETUP_REQUEST';
export const NBS_API_DISABLE_NEARBY_CONNECT_SETUP_SUCCESS =
  'NBS_API_DISABLE_NEARBY_CONNECT_SETUP_SUCCESS';
export const NBS_API_DISABLE_NEARBY_CONNECT_SETUP_FAILURE =
  'NBS_API_DISABLE_NEARBY_CONNECT_SETUP_FAILURE';
export const NBS_API_RESET_DISABLE_CONNECT = 'NBS_API_RESET_DISABLE_CONNECT';

export const NBS_API_UPDATE_NEARBY_CONNECT_SETUP_REQUEST =
  'NBS_API_UPDATE_NEARBY_CONNECT_SETUP_REQUEST';
export const NBS_API_UPDATE_NEARBY_CONNECT_SETUP_SUCCESS =
  'NBS_API_UPDATE_NEARBY_CONNECT_SETUP_SUCCESS';
export const NBS_API_UPDATE_NEARBY_CONNECT_SETUP_FAILURE =
  'NBS_API_UPDATE_NEARBY_CONNECT_SETUP_FAILURE';
export const NBS_API_RESET_UPDATE_CONNECT = 'NBS_API_RESET_UPDATE_CONNECT';

export const NBS_API_CHECK_PUBLIC_TEXT_REQUEST =
  'NBS_API_CHECK_PUBLIC_TEXT_REQUEST';
export const NBS_API_CHECK_PUBLIC_TEXT_SUCCESS =
  'NBS_API_CHECK_PUBLIC_TEXT_SUCCESS';
export const NBS_API_CHECK_PUBLIC_TEXT_FAILURE =
  'NBS_API_CHECK_PUBLIC_TEXT_FAILURE';
export const RESET_CHECK_PUBLIC_TEXT = 'RESET_CHECK_PUBLIC_TEXT';

export const SET_COOKIES_MODAL = 'SET_COOKIES_MODAL';

export const SET_PROMO_ID_FROM_CHAT = 'SET_PROMO_ID_FROM_CHAT';

export const NBS_API_RESEND_CONFIRMATION_EMAIL_REQUEST =
  'NBS_API_RESEND_CONFIRMATION_EMAIL_REQUEST';
export const NBS_API_RESEND_CONFIRMATION_EMAIL_SUCCESS =
  'NBS_API_RESEND_CONFIRMATION_EMAIL_SUCCESS';
export const NBS_API_RESEND_CONFIRMATION_EMAIL_FAILURE =
  'NBS_API_RESEND_CONFIRMATION_EMAIL_FAILURE';

export const DELETE_CHAT = 'DELETE_CHAT';

export const SET_META_PIXELS = 'SET_META_PIXELS';
